/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createObservableDataAction, IAction, IActionInput } from '@msdyn365-commerce/core';
import { GenericInput, getGenericAction } from '@msdyn365-commerce-modules/retail-actions';

import { IActiveTabState } from './tab-state';

export function createTabStateInput(result: IActiveTabState): GenericInput<IActiveTabState> {
    return new GenericInput<IActiveTabState>('activeTabState', result, 'IActiveTabState');
}

const createTabStateInputInternal = (): IActionInput => {
    return createTabStateInput({});
};

export const getGenericActionDataAction = createObservableDataAction({
    action: <IAction<IActiveTabState>>getGenericAction,
    input: createTabStateInputInternal
});

export default getGenericActionDataAction;
